import * as m from "@paraglide/messages"
import type { SupportedLocale } from "@playbrain/content-types"

/**
 * The six report pages the microsite shows as proof of what a report contains.
 *
 * The screenshots are localised — the report itself is rendered in the reader's
 * language — so the file stem carries the locale. Captions reuse the event
 * report's contents list so the labels and the images cannot drift apart.
 */
const reportPages = [3, 4, 6, 7, 9, 11] as const

export function PlaydataReportGallery({ locale }: { locale: SupportedLocale }) {
  const captions = [
    m.playdata_eventReport_example_item1({}, { locale }),
    m.playdata_eventReport_example_item2({}, { locale }),
    m.playdata_eventReport_example_item3({}, { locale }),
    m.playdata_eventReport_example_item4({}, { locale }),
    m.playdata_eventReport_example_item5({}, { locale }),
    m.playdata_eventReport_example_item6({}, { locale }),
  ]

  return (
    <ul className="grid gap-[1.6rem] sm:grid-cols-2 lg:grid-cols-3">
      {reportPages.map((page, index) => (
        <li
          key={page}
          className="flex flex-col gap-[0.8rem]"
        >
          <img
            alt={captions[index] ?? ""}
            className="h-auto w-full border border-play-white-30 bg-play-white"
            height={1080}
            loading="lazy"
            src={`/images/playdata/sample-${locale}-${page}.jpg`}
            width={1920}
          />
          <p className="text-[1.4rem] opacity-80">{captions[index]}</p>
        </li>
      ))}
    </ul>
  )
}

export default PlaydataReportGallery
